<h1 mat-dialog-title>Filters List</h1>
<div mat-dialog-content  style="max-height: 300px; overflow-y: auto; background-color: whitesmoke;">

  <mat-chip-grid *ngIf="data?.selectedCompanyNames?.length> 0" class="m-2">
    <small>Companies: </small>
    <ng-container *ngFor="let company of data?.selectedCompanyNames">
      <mat-chip (removed)="removeItemFromArray(company, 'selectedCompanyNames')">
        <small>{{ company?.name || company }}</small>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </ng-container>
    <button mat-icon-button class="example-icon" *ngIf="data.selectedCompanyNames?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear companies" placement="bottom" (click)="removeAllItemsFromArray('selectedCompanyNames')">
      <mat-icon >backspace</mat-icon>
    </button>
  </mat-chip-grid>

  <mat-chip-grid *ngIf="data?.selectedIncludeItems?.length> 0" class="m-2">
    <small>Include Companies: </small>
    <ng-container *ngFor="let company of data?.selectedIncludeItems">
      <mat-chip (removed)="removeItemFromArray(company, 'selectedIncludeItems')">
        <small>{{ company?.name || company }}</small>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </ng-container>
    <button mat-icon-button class="example-icon" *ngIf="data.selectedIncludeItems?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear include companies" placement="bottom" (click)="removeAllItemsFromArray('selectedIncludeItems')">
      <mat-icon >backspace</mat-icon>
    </button>
  </mat-chip-grid>

  <mat-chip-grid *ngIf="data?.selectedExcludeItems?.length> 0" class="m-2">
    <small>Exclude Companies: </small>
    <ng-container *ngFor="let company of data?.selectedExcludeItems">
      <mat-chip (removed)="removeItemFromArray(company, 'selectedExcludeItems')">
        <small>{{ company?.name || company }}</small>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </ng-container>
    <button mat-icon-button class="example-icon" *ngIf="data.selectedExcludeItems?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear exclude companies" placement="bottom" (click)="removeAllItemsFromArray('selectedExcludeItems')">
      <mat-icon >backspace</mat-icon>
    </button>
  </mat-chip-grid>


  <mat-chip-grid *ngIf="data.selectedWebsites?.length > 0" class="m-2">
    <small>Websites: </small>
    <ng-container *ngFor="let website of data?.selectedWebsites">
        <mat-chip (removed)="removeItemFromArray(website, 'selectedWebsites')">
          <small>{{ website }}</small>
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
    </ng-container>
    <button mat-icon-button class="example-icon" *ngIf="data.selectedWebsites?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear websites" placement="bottom" (click)="removeAllItemsFromArray('selectedWebsites')">
      <mat-icon >backspace</mat-icon>
    </button>
  </mat-chip-grid>


  <mat-chip-grid *ngIf="data.selectedProductsIn?.length > 0" class="m-2">
    <small>Products In: </small>
    <ng-container *ngFor="let product of data?.selectedProductsIn">
      <mat-chip (removed)="removeItemFromArray(product, 'selectedProductsIn')">
        <small>{{ product.name }}</small>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </ng-container>
    <button mat-icon-button class="example-icon" *ngIf="data.selectedProductsIn?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear products in" placement="bottom" (click)="removeAllItemsFromArray('selectedProductsIn')">
      <mat-icon >backspace</mat-icon>
    </button>
  </mat-chip-grid>

  <mat-chip-grid *ngIf="data.selectedProductsNotIn?.length > 0" class="m-2">
    <small>Products Ex: </small>
    <ng-container *ngFor="let product of data?.selectedProductsNotIn">
      <mat-chip (removed)="removeItemFromArray(product, 'selectedProductsNotIn')">
        <small>{{ product.name }}</small>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </ng-container>
    <button mat-icon-button class="example-icon" *ngIf="data.selectedProductsNotIn?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear products not in" placement="bottom" (click)="removeAllItemsFromArray('selectedProductsNotIn')">
      <mat-icon >backspace</mat-icon>
    </button>
  </mat-chip-grid>

  <mat-chip-grid *ngIf="data.selectedCategoriesIn?.length > 0" class="m-2">
    <small>Categories In: </small>
    <ng-container *ngFor="let category of data?.selectedCategoriesIn">
        <mat-chip (removed)="removeItemFromArray(category, 'selectedCategoriesIn')">
          <small>{{ category.name }}</small>
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
    </ng-container>
    <button mat-icon-button class="example-icon" *ngIf="data.selectedCategoriesIn?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear categories in" placement="bottom" (click)="removeAllItemsFromArray('selectedCategoriesIn')">
      <mat-icon >backspace</mat-icon>
    </button>
  </mat-chip-grid>

  <mat-chip-grid *ngIf="data.selectedCategoriesNotIn?.length > 0" class="m-2">
    <small>Categories Ex: </small>
    <ng-container *ngFor="let category of data?.selectedCategoriesNotIn">
      <mat-chip (removed)="removeItemFromArray(category, 'selectedCategoriesNotIn')">
        <small>{{ category.name }}</small>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </ng-container>
    <button mat-icon-button class="example-icon" *ngIf="data.selectedCategoriesNotIn?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear categories not in" placement="bottom" (click)="removeAllItemsFromArray('selectedCategoriesNotIn')">
      <mat-icon >backspace</mat-icon>
    </button>
  </mat-chip-grid>

  <mat-chip-grid *ngIf="data.selectedCategoriesNotIn?.length > 0" class="m-2">
    <small>Categories Ex: </small>
    <ng-container *ngFor="let category of data?.selectedCategoriesNotIn">
      <mat-chip (removed)="removeItemFromArray(category, 'selectedCategoriesNotIn')">
        <small>{{ category.name }}</small>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </ng-container>
    <button mat-icon-button class="example-icon" *ngIf="data.selectedCategoriesNotIn?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear categories not in" placement="bottom" (click)="removeAllItemsFromArray('selectedCategoriesNotIn')">
      <mat-icon >backspace</mat-icon>
    </button>
  </mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedVendorsIn?.length > 0" class="m-2">
  <small>Vendors In: </small>
  <ng-container *ngFor="let vendor of data?.selectedVendorsIn">
    <mat-chip (removed)="removeItemFromArray(vendor, 'selectedVendorsIn')">
      <small>{{ vendor.name }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedVendorsIn?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear vendors in" placement="bottom" (click)="removeAllItemsFromArray('selectedVendorsIn')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedVendorsNotIn?.length > 0" class="m-2">
  <small>Vendors Ex: </small>
  <ng-container *ngFor="let vendor of data?.selectedVendorsNotIn">
    <mat-chip (removed)="removeItemFromArray(vendor, 'selectedVendorsNotIn')">
      <small>{{ vendor.name }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedVendorsNotIn?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear vendors not in" placement="bottom" (click)="removeAllItemsFromArray('selectedVendorsNotIn')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedIndustries?.length > 0" class="m-2">
  <small>Industries: </small>
  <ng-container *ngFor="let industry of data?.selectedIndustries">
    <mat-chip (removed)="removeItemFromArray(industry, 'selectedIndustries')">
      <small>{{ industry }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedIndustries?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear industries" placement="bottom" (click)="removeAllItemsFromArray('selectedIndustries')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedEmployees?.length > 0" class="m-2">
  <small>Employees: </small>
  <ng-container *ngFor="let employe of data?.selectedEmployees">
    <mat-chip (removed)="removeItemFromArray(employe, 'selectedEmployees')">
      <small>{{ employe }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedEmployees?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear employees" placement="bottom" (click)="removeAllItemsFromArray('selectedEmployees')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedRevenues?.length > 0" class="m-2">
  <small>Revenues: </small>
  <ng-container *ngFor="let revenue of data?.selectedRevenues">
    <mat-chip (removed)="removeItemFromArray(revenue, 'selectedRevenues')">
      <small>{{ revenue}}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedRevenues?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear revenues" placement="bottom" (click)="removeAllItemsFromArray('selectedRevenues')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedLocation?.length > 0" class="m-2">
  <small>Locations: </small>
  <ng-container *ngFor="let location of data?.selectedLocation">
    <mat-chip (removed)="removeItemFromArray(location, 'selectedLocation')">
      <small>{{ location }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedLocation?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear locations" placement="bottom" (click)="removeAllItemsFromArray('selectedLocation')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedCountries?.length > 0" class="m-2">
  <small>Countries </small>
  <ng-container *ngFor="let country of data?.selectedCountries">
    <mat-chip (removed)="removeItemFromArray(country, 'selectedCountries')">
      <small>{{ country.name }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedCountries?.length > 0  && showAllRemove" color="warn" ngbTooltip="Clear countries" placement="bottom" (click)="removeAllItemsFromArray('selectedCountries')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedDepartments?.length > 0" class="m-2">
  <small>Departments</small>
  <ng-container *ngFor="let department of data?.selectedDepartments">
    <mat-chip (removed)="removeItemFromArray(department, 'selectedDepartments')">
      <small>{{ department }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedDepartments?.length > 0  && showAllRemove" color="warn" ngbTooltip="Clear departments" placement="bottom" (click)="removeAllItemsFromArray('selectedDepartments')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedLevels?.length > 0" class="m-2">
  <small>Levels</small>
  <ng-container *ngFor="let item of data?.selectedLevels">
    <mat-chip (removed)="removeItemFromArray(item, 'selectedLevels')">
      <small>{{ item }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedLevels?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear levels" placement="bottom" (click)="removeAllItemsFromArray('selectedLevels')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedTitles?.length > 0" class="m-2">
  <small>Titles</small>
  <ng-container *ngFor="let item of data?.selectedTitles">
    <mat-chip (removed)="removeItemFromArray(item, 'selectedTitles')">
      <small>{{ item }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedTitles?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear titles" placement="bottom" (click)="removeAllItemsFromArray('selectedTitles')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedSkills?.length > 0" class="m-2">
  <small>Skills</small>
  <ng-container *ngFor="let item of data?.selectedSkills">
    <mat-chip (removed)="removeItemFromArray(item, 'selectedSkills')">
      <small>{{ item }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedSkills?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear skills" placement="bottom" (click)="removeAllItemsFromArray('selectedSkills')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedEducations?.length > 0" class="m-2">
  <small>Educations</small>
  <ng-container *ngFor="let item of data?.selectedEducations">
    <mat-chip (removed)="removeItemFromArray(item, 'selectedEducations')">
      <small>{{ item }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedEducations?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear educations" placement="bottom" (click)="removeAllItemsFromArray('selectedEducations')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedEmailsOrPhones?.length > 0" class="m-2">
  <small>Emails Or Phones</small>
  <ng-container *ngFor="let item of data?.selectedEmailsOrPhones">
    <mat-chip (removed)="removeItemFromArray(item, 'selectedEmailsOrPhones')">
      <small>{{ item }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedEmailsOrPhones?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear emails or phones" placement="bottom" (click)="removeAllItemsFromArray('selectedEmailsOrPhones')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedSocialLinks?.length > 0" class="m-2">
  <small>Social Links</small>
  <ng-container *ngFor="let item of data?.selectedSocialLinks">
    <mat-chip (removed)="removeItemFromArray(item, 'selectedSocialLinks')">
      <small>{{ item }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedSocialLinks?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear social links" placement="bottom" (click)="removeAllItemsFromArray('selectedSocialLinks')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedLocations?.length > 0" class="m-2">
  <small>Selected Profile Locations</small>
  <ng-container *ngFor="let item of data?.selectedLocations">
    <mat-chip (removed)="removeItemFromArray(item, 'selectedLocations')">
      <small>{{ item }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
    <button mat-icon-button class="example-icon" *ngIf="data.selectedLocations?.length > 0  && showAllRemove" color="warn" ngbTooltip="Clear profile locations" placement="bottom" (click)="removeAllItemsFromArray('selectedLocations')">
      <mat-icon >backspace</mat-icon>
    </button>
  </ng-container>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedCompanyLocationIn?.length > 0" class="m-2">
  <small>Company Locations</small>
  <ng-container *ngFor="let item of data?.selectedCompanyLocationIn">
    <mat-chip (removed)="removeItemFromArray(item, 'selectedCompanyLocationIn')">
      <small>{{ item }}</small>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>

  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedCompanyLocationIn?.length > 0  && showAllRemove" color="warn" ngbTooltip="Clear company Locations" placement="bottom" (click)="removeAllItemsFromArray('selectedCompanyLocationIn')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

<mat-chip-grid *ngIf="data.selectedCompanyWebsites?.length > 0" class="m-2">
  <small>Company websites: </small>
  <ng-container *ngFor="let website of data?.selectedCompanyWebsites">
      <mat-chip (removed)="removeItemFromArray(website, 'selectedCompanyWebsites')">
        <small>{{ website }}</small>
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
  </ng-container>
  <button mat-icon-button class="example-icon" *ngIf="data.selectedCompanyWebsites?.length > 0 && showAllRemove" color="warn" ngbTooltip="Clear company websites" placement="bottom" (click)="removeAllItemsFromArray('selectedCompanyWebsites')">
    <mat-icon >backspace</mat-icon>
  </button>
</mat-chip-grid>

</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button  mat-raised-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
</div>
